import { render, staticRenderFns } from "./Mindo.vue?vue&type=template&id=b012b6b0&"
import script from "./Mindo.vue?vue&type=script&lang=js&"
export * from "./Mindo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports